import React, { ReactNode } from 'react';
import './Link.less';

export type LinkProps = {
  icon?: ReactNode;
  href: string;
  title?: string | ReactNode;
  target?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};
const TLink: React.FC<LinkProps> = ({ ...props }) => {
  return (
    <a
      href={props.href}
      className={'link-container'}
      target={props.target}
      onClick={props.onClick}
    >
      {props.icon}
      <span>{props.title}</span>
    </a>
  );
};

export default TLink;
